import { render } from "./earlyWarning.vue?vue&type=template&id=bb84e372&scoped=true"
import script from "./earlyWarning.vue?vue&type=script&lang=js"
export * from "./earlyWarning.vue?vue&type=script&lang=js"

import "./earlyWarning.vue?vue&type=style&index=0&id=bb84e372&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb84e372"]])

export default __exports__